import * as angular from 'angular';

angular
  .module('screeningcanvas')
  .filter('formatSigned', function () {
    return function (input) {
      if (input != null && typeof input !== 'undefined') {
        return ((input >= 0) ? "+" : "") + (input);
      } else {
        return null;
      }
    };
  });
